export default "__VITE_ASSET__BpUTLB$8__"